import { render, staticRenderFns } from "./FormDadosAtendimento.vue?vue&type=template&id=3c2fb6cc"
import script from "./FormDadosAtendimento.vue?vue&type=script&lang=js"
export * from "./FormDadosAtendimento.vue?vue&type=script&lang=js"
import style0 from "./FormDadosAtendimento.vue?vue&type=style&index=0&id=3c2fb6cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports